import React, { useRef, useState } from 'react';
import {
    Modal,
    NotificationType,
} from '@instinet-analytics/semantic-ui-components';

import {
    IndexMappingEditorPanelRef,
    IndexMappingsEditorPanel,
} from '../IndexMappingsEditorPanel/IndexMappingsEditorPanel';
import './IndexMappingsEditorModal.scss';
import { useDispatchShowNotification } from 'notification/store/dispatcher';
import { PubSub } from '@instinet-analytics/core-lib';

export function IndexMappingsEditorModal() {
    const dispatchNotification = useDispatchShowNotification();

    const panelRef = React.useRef<IndexMappingEditorPanelRef>(null);
    const [okToSave, setOkToSave] = useState(true);

    const onOpen = () => {
        panelRef.current && panelRef.current.reset();
    };

    const closePubSubRef = useRef(new PubSub<void>());

    const onSave = () => {
        (async () => {
            try {
                const saved = await panelRef.current!.saveMappings();

                if (!saved) {
                    return { cancel: true };
                }
            } catch (err) {
                dispatchNotification(
                    'Error saving mappings',
                    NotificationType.Warning
                );
            }
            closePubSubRef.current.publish();
        })();

        return { cancel: true };
    };
    const onCancel = () => {
        panelRef.current!.reset();
    };

    return (
        <Modal
            className="SettingsModal IndexMappingsEditorModal"
            trigger={
                <div className="IndexMappingsEditorModal-trigger link-text">
                    Edit...
                </div>
            }
            headerText="Indigo Preferences: Symbol to Index Mappings"
            saveText="Apply and Close"
            onOpen={onOpen}
            onSave={onSave}
            allowCancel={true}
            onCancel={onCancel}
            disableSaveButton={!okToSave}
            closePubSub={closePubSubRef.current}
        >
            <IndexMappingsEditorPanel
                ref={panelRef}
                onOkToSaveChanged={setOkToSave}
                showTestPanel={true}
            />
        </Modal>
    );
}
